import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative min-h-screen w-full pt-16 flex items-center justify-center overflow-hidden" data-id="element-29">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-30">
        <img src="https://cdn.magicpatterns.com/uploads/aVYrb8HEFan8naTYPt86QN/ChatGPT_Image_22_feb_2026,_06_07_02_p.m..png" alt="Background" className="w-full h-full object-cover" data-id="element-31" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70" data-id="element-32" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-6 py-8 text-center" data-id="element-33">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="inline-block mb-6" data-id="element-34">
          <span className="bg-transparent text-yellow-400 px-8 py-3 rounded-full text-sm font-bold shadow-lg inline-flex items-center gap-3 border-2 border-yellow-500" data-id="element-35">
            <span data-id="element-36">⭐</span>
            EL RECURSO #1 PARA DOCENTES DE ARTE
            <span data-id="element-37">⭐</span>
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-3xl md:text-4xl lg:text-5xl font-black text-white leading-none" style={{
        fontFamily: 'Georgia, serif',
        fontWeight: 900
      }} data-id="element-38">
          Mega Pack de Arte:
        </motion.h1>

        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="text-3xl md:text-4xl lg:text-5xl font-black mb-3 leading-none" style={{
        color: '#d4af37',
        fontFamily: 'Georgia, serif',
        fontWeight: 900
      }} data-id="element-39">
          Herramientas Completas
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1,
        y: [0, -15, 0]
      }} transition={{
        opacity: {
          duration: 1,
          delay: 0.5
        },
        scale: {
          duration: 1,
          delay: 0.5
        },
        y: {
          duration: 3,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 1.5
        }
      }} className="mb-3" data-id="element-40">
          <img src="https://cdn.magicpatterns.com/uploads/5S9vXAEoz5kqAgN1vM5soQ/Diseno_sin_titulo_(1).png" alt="Mega Pack Artística Lista - Paquete completo de recursos educativos" className="w-56 md:w-72 mx-auto h-auto" data-id="element-41" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.7
      }} className="text-base md:text-lg text-white mb-4 max-w-3xl mx-auto leading-relaxed" style={{
        fontFamily: 'Inter, sans-serif'
      }} data-id="element-42">
          Planificaciones, dinámicas y proyectos listos para usar en el aula o
          talleres. Transformá tus clases hoy mismo.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.9
      }} className="flex flex-col items-center justify-center gap-4 w-full max-w-2xl mx-auto" data-id="element-43">
          <a href="#comprar" className="w-full bg-red-700 text-white px-10 py-5 rounded-xl font-bold text-xl shadow-xl hover:bg-red-800 transition-all duration-300 inline-flex items-center justify-center gap-2" data-id="element-44">
            Adquirir Ahora
            <span data-id="element-45">→</span>
          </a>
          <a href="#incluye" className="w-full bg-black/40 backdrop-blur-sm text-white px-10 py-5 rounded-xl font-bold text-xl border-2 border-white/30 hover:bg-white/10 transition-all duration-300" data-id="element-46">
            Más Información
          </a>
        </motion.div>
      </div>

      {/* Social Proof Notification */}
      <motion.div initial={{
      opacity: 0,
      x: -100
    }} animate={{
      opacity: 1,
      x: 0
    }} transition={{
      delay: 2,
      duration: 0.5
    }} className="absolute bottom-8 left-8 bg-gray-900/90 backdrop-blur-sm text-white px-6 py-4 rounded-lg shadow-2xl max-w-xs hidden lg:block" data-id="element-47">
        <div className="flex items-start gap-3" data-id="element-48">
          <div className="w-10 h-10 bg-yellow-600 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-49">
            <span className="text-xl" data-id="element-50">🛍️</span>
          </div>
          <div data-id="element-51">
            <p className="font-bold text-sm" data-id="element-52">
              <span className="text-yellow-400" data-id="element-53">Ana López</span> de San Juan
            </p>
            <p className="text-xs text-gray-300" data-id="element-54">
              adquirió el <span className="font-semibold" data-id="element-55">Mega Pack</span>
            </p>
            <p className="text-xs text-gray-400 mt-1" data-id="element-56">Hace 3 minutos</p>
          </div>
        </div>
      </motion.div>
    </section>;
}